import { Check, Copy } from "lucide-react";
import { useState } from "react";

// Inline value chip with a copy button. Multiline-safe: pass newline-joined
// text (e.g. a scope list) and it renders line-by-line, copies the whole thing.
export function CopyableValue({
  value,
  className = "",
}: {
  value: string;
  className?: string;
}) {
  const [copied, setCopied] = useState(false);
  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // navigator.clipboard needs a secure context — no-op outside HTTPS
      // rather than throwing; the value stays select-all for manual copy.
    }
  };
  return (
    <div
      className={`flex items-stretch overflow-hidden rounded-md border border-border bg-muted/40 ${className}`}
    >
      <code className="flex-1 px-3 py-2 text-xs font-mono leading-relaxed break-all whitespace-pre-line select-all">
        {value}
      </code>
      <button
        type="button"
        onClick={onCopy}
        className="flex items-center gap-1 border-l border-border px-3 text-xs font-medium text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
        title="Copy to clipboard"
      >
        {copied ? (
          <>
            <Check className="size-3.5 text-emerald-600" />
            <span>Copied</span>
          </>
        ) : (
          <>
            <Copy className="size-3.5" />
            <span>Copy</span>
          </>
        )}
      </button>
    </div>
  );
}
